import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFormElementsNoIntent, emailIntentSelected, getHardCodeTopicWebForm } from '../actions/action-email-no-intent';
import { selectTopicResult } from '../actions/action-select-topic';
import { trackLink } from '../../lib/analytics-helper';
import TopicSelection from '../components/TopicSelection';
import EmailForm from './EmailForm';
import PrivacyEmailForm from './PrivacyEmailForm';
import i18n from '../../lib/reacti18n';
import { TOPICTREE } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import { updateUserSelection } from '../actions/action-update-user-selection';
import { isPUIIntentEnabled } from '../../lib/puiTopicHelper';
import l10n from '../../lib/reactPPl10nHelper';
import { isPrivacyWebFormEnabledInRC } from '../../lib/globalHelper';
import { urlConstants } from '../../common/commonConstants';

const email = {
  header: i18n.message('smarthelp/emailUs.emailUs.header'),
  instruction: i18n.message('smarthelp/emailUs.emailUs.instruction'),
  placeholder1: i18n.message('smarthelp/emailUs.emailUs.placeholder1'),
  placeholder2: i18n.message('smarthelp/emailUs.emailUs.placeholder2'),
  error: l10n.getContent('smarthelp/Error.error.email.newInvalid', { helpCenterUrl: urlConstants.HELP_CENTER_URL }),
};

class EmailNoIntent extends Component {
  static renderError() {
    return (
      <div className="error-email-no-intent">
        <div className="vx_icon vx_icon-large vx_icon-critical-large test" />
        <div className="error-message-email-no-intent">{Page.getHTMLElement({ message: email.error, useHTML: true })}</div>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      topicSelections: props.topicTree,
      value: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      label: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      isFirstTime: true,
    };
    this.onTopicSelection = this.onTopicSelection.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isFirstTime && nextProps.topicSelection) {
      this.setState({
        topicSelections: nextProps.topicTree,
        isFirstTime: false,
      });
    }
  }

  onTopicSelection({
    topicRefId, topicId, topicName, topicObj, level, webForms,
  }) {
    trackLink({ id: 'emailByPassPage', link: `smarthelp-email-select|L${level + 1}|${topicRefId}` });
    // Set dropdown value
    const value = this.state.value.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      } if (index === level) {
        return topicRefId;
      }
      return eachValue;
    });
    this.setState({
      value,
    });
    // set label to empty to hide it
    const label = this.state.label.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      } if (index === level) {
        return '';
      }
      return eachValue;
    });
    this.setState({
      label,
    });
    this.props.emailIntentSelected(topicName);

    // Set local state for current level Topic tree selection
    const updatedSelection = this.state.topicSelections.slice(0, level + 1);
    updatedSelection.push(topicObj);
    this.setState({
      topicSelections: updatedSelection,
    });

    // check if its a leafnode, then fetch email form and trigger select topic result event
    if (topicObj && topicObj.leaf_node) {
      this.props.selectTopicResult({
        topicId,
        topicName,
        topicRefId,
      });
      if (Page.isUsingHardcodeEmailForm() && webForms) {
        this.props.getHardCodeTopicWebForm({ webForms, topicRefId });
      } else {
        this.props.fetchFormElementsNoIntent(topicId);
      }
    }
  }

  renderDropDown(topic, level) {
    let topicSelection = null;
    if (topic && topic.sub_topics) {
      const topicObject = topic.sub_topics.map((eachTopic) => {
        const topicOptions = {
          topicRefId: eachTopic.ref_id,
          topicId: eachTopic.topic_id,
          topicName: eachTopic.topic_name,
          topicObj: eachTopic,
          level,
        };

        // Putting webForm Data inside the topic tree options
        if (Page.isUsingHardcodeEmailForm() && eachTopic.web_forms) {
          topicOptions.webForms = eachTopic.web_forms;
        }
        return topicOptions;
      });

      const options = topicObject.map((eachTopic) => ({
        label: eachTopic.topicName,
        value: eachTopic.topicRefId,
      }));

      topicSelection = (
        <TopicSelection
          options={options}
          topics={topicObject}
          level={level}
          onChange={this.onTopicSelection}
          label={this.state.label[level]}
          value={this.state.value[level]}
          placeholder={this.state.value[level]}
        />
      );
    }
    return topicSelection;
  }

  renderTopicSelection() {
    if (this.props.isLogoutForm) {
      return null;
    }

    return (
      <div className="email-no-intent-selection">
        <div className="email-no-intent-instruction">{email.instruction}</div>
        {this.state.topicSelections.map((topic, index) => this.renderDropDown(topic, index))}
      </div>
    );
  }

  renderEmailHeader() {
    const { kanaCode } = this.props;

    // For PAYPUI001 Tcode do not render email header on the top, it will bee below the page information text
    if (!kanaCode || isPUIIntentEnabled(kanaCode)) {
      return <p />;
    }
    return <p className="email-no-intent-header">{email.header}</p>;
  }

  render() {
    const {
      error, display, kanaCode, isIdiLoading, isIdiServiceLoaded, topicName,
    } = this.props;

    if (error) {
      return EmailNoIntent.renderError();
    } if (display) {
      // if the request is from Pay upon invoice trigger IDI call to check for chat eligibility
      // Only after getting the kanaCode check for pui topic validation
      if (kanaCode && (isPUIIntentEnabled(kanaCode) || isPrivacyWebFormEnabledInRC(kanaCode)) && !isIdiLoading && !isIdiServiceLoaded) {
        this.props.updateUserSelection('emailByPassPage', topicName);
      }
      if (isPrivacyWebFormEnabledInRC(kanaCode)) {
        return <PrivacyEmailForm />;
      }
      return (
        <div className="email-no-intent">
          {this.renderEmailHeader()}
          {this.renderTopicSelection()}
          <EmailForm />
        </div>
      );
    }
    return null;
  }
}

// EmailNoIntent PropTypes
EmailNoIntent.propTypes = {
  topicTree: PropTypes.arrayOf(PropTypes.shape(TOPICTREE)),
  topicSelection: PropTypes.shape(TOPICTREE), // eslint-disable-line react/no-unused-prop-types
  fetchFormElementsNoIntent: PropTypes.func.isRequired,
  getHardCodeTopicWebForm: PropTypes.func.isRequired,
  selectTopicResult: PropTypes.func.isRequired,
  emailIntentSelected: PropTypes.func.isRequired,
  error: PropTypes.bool,
  display: PropTypes.bool,
  isLogoutForm: PropTypes.bool,
  updateUserSelection: PropTypes.func.isRequired,
  kanaCode: PropTypes.string.isRequired,
  isIdiLoading: PropTypes.bool.isRequired,
  isIdiServiceLoaded: PropTypes.bool.isRequired,
  topicName: PropTypes.string.isRequired,
};

EmailNoIntent.defaultProps = {
  topicTree: [],
  topicSelection: undefined,
  error: false,
  display: false,
  isLogoutForm: false,
};

function mapStateToProps(state) {
  const topicTree = [];
  topicTree.push(state.topicTree.topicTreeSelection);
  return {
    topicTree,
    topicSelection: state.topicTree.topicTreeSelection,
    error: state.topicTree.error,
    display: state.topicTree.display,
    isLogoutForm: state.emailNoIntent.isLogoutForm,
    kanaCode: state.emailNoIntent.kanaCode,
    isIdiLoading: state.contactChannels.isIdiLoading,
    isIdiServiceLoaded: state.contactChannels.isIdiServiceLoaded,
    topicName: state.emailNoIntent.topicName,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchFormElementsNoIntent, getHardCodeTopicWebForm, selectTopicResult, emailIntentSelected, updateUserSelection,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailNoIntent);
